<template>
  <div v-if="broadcast" class="mt-5">
    <v-btn flat @click="onBack">
      <i class="fas fa-chevron-left mr-1"></i>
      {{ $t('Back') }}
    </v-btn>
    <v-container>
      <h3 class="headline">{{ $t('Broadcast Detail') }}</h3>
    </v-container>

    <template v-if="broadcast">
      <v-container>
        <div>{{ $t('Broadcast Name') }}</div>
        <div class="primary--text">{{ name }}</div>
      </v-container>
      <v-divider></v-divider>
      <v-container>
        <div>{{ $t('Message Type') }}</div>
        <div class="primary--text" v-if="sendtype == 'subscription'">{{ $t('Subscription') }}</div>
        <div class="primary--text" v-else-if="sendtype == 'promotion'">{{ $t('Promotion') }}</div>
      </v-container>
      <v-divider></v-divider>
      <v-container>
        <div>{{ $t('Notification Setting') }}</div>
        <div class="primary--text" v-if="pushtype == 'REGULAR'">{{ $t('Regular Push') }}</div>
        <div class="primary--text" v-else-if="pushtype == 'SILENT_PUSH'">
          {{ $t('Silent Push') }}
        </div>
        <div class="primary--text" v-else-if="pushtype == 'NO_PUSH'">{{ $t('No Push') }}</div>
      </v-container>
      <v-divider></v-divider>
      <v-container>
        <div>{{ $t('Target') }}</div>
        <div>
          <template v-if="groupType == ''">
            <div class="primary--text mt-3">{{ $t('All') }}</div>
          </template>
          <template v-else-if="groupType == 'male'">
            <div class="primary--text mt-3">{{ $t('Male') }}</div>
          </template>
          <template v-else-if="groupType == 'female'">
            <div class="primary--text mt-3">{{ $t('Female') }}</div>
          </template>
          <template v-else-if="groupType == 'customize'">
            <table class="mt-3">
              <tr>
                <td>{{ $t('name') }}</td>
                <td class="primary-color">{{ filter.fullname ? filter.fullname : '-' }}</td>
              </tr>
              <tr>
                <td>{{ $t('gender') }}</td>
                <td class="primary-color">
                  <template v-if="filter.gender == 'male'">{{ $t('Male') }}</template>
                  <template v-else-if="filter.gender == 'female'">{{ $t('Female') }}</template>
                  <template v-else-if="filter.gender == 'all'">{{ $t('All') }}</template>
                </td>
              </tr>
              <tr>
                <td>{{ $t('Locale') }}</td>
                <td class="primary-color">
                  <template v-if="filter.locale && filter.locale.length > 0">
                    <span v-for="(locale, index) in filter.locale" :key="'locale_' + index">
                      <flag :iso="locale.icon" />
                      {{ locale.title }}
                      <template v-if="index != filter.locale.length - 1"
                        >,</template
                      >
                    </span>
                  </template>
                  <template v-else
                    >-</template
                  >
                </td>
              </tr>
              <tr>
                <td>{{ $t('Channel') }}</td>
                <td class="primary-color">
                  <span style="color: #3b5998" v-if="filter.app == 'facebook'">
                    <i class="fab fa-facebook-square"></i> Facebook
                  </span>
                  <span style="color: #00c300" v-else-if="filter.app == 'line'">
                    <i class="fab fa-line"></i> Line
                  </span>
                  <span v-else>{{ $t('All') }}</span>
                </td>
              </tr>
              <tr>
                <td>{{ $t('Conversation') }}</td>
                <td class="primary-color">
                  <template v-if="filter.intent && filter.intent.length > 0">
                    <span v-for="(intent, index) in filter.intent" :key="'intent_' + index">
                      {{ intent }}
                      <template v-if="index != filter.intent.length - 1"
                        >,</template
                      >
                    </span>
                  </template>
                  <template v-else
                    >-</template
                  >
                </td>
              </tr>
              <tr>
                <td>{{ $t('Email') }}</td>
                <td class="primary-color">{{ filter.email ? filter.email : '-' }}</td>
              </tr>
              <tr>
                <td>{{ $t('phone no.') }}</td>
                <td class="primary-color">{{ filter.phoneno ? filter.phoneno : '-' }}</td>
              </tr>
              <tr v-if="filter.messagesent.value != '' || filter.messagesent.value != null">
                <td>{{ $t('Message Sent') }}</td>
                <td class="primary-color">
                  {{
                    filter.messagesent.symbol == 'g__'
                      ? $t('Greater than')
                      : filter.messagesent.symbol == 'l__'
                      ? $t('Less than')
                      : $t('Not')
                  }}
                  {{ filter.messagesent.value }}
                </td>
              </tr>
              <tr v-if="filter.registerDate.start || filter.registerDate.end">
                <td>{{ $t('First Conversation at') }}</td>
                <td class="primary-color">
                  <template v-if="filter.registerDate.start"
                    >{{ filter.registerDate.start | DateFormat('DD/MM/YYYY') }} -</template
                  >
                  <template v-if="filter.registerDate.end">{{
                    filter.registerDate.end | DateFormat('DD/MM/YYYY')
                  }}</template>
                </td>
              </tr>
              <tr v-if="filter.activeDate.start || filter.activeDate.end">
                <td>{{ $t('Last Conversation at') }}</td>
                <td class="primary-color">
                  <template v-if="filter.activeDate.start"
                    >{{ filter.activeDate.start | DateFormat('DD/MM/YYYY') }} -</template
                  >
                  <template v-if="filter.activeDate.end">{{
                    filter.activeDate.end | DateFormat('DD/MM/YYYY')
                  }}</template>
                </td>
              </tr>
              <tr>
                <td>{{ $t('Tag') }}</td>
                <td class="primary-color">{{ filter.tag ? filter.tag : '-' }}</td>
              </tr>
              <tr>
                <td>{{ $t('Status') }}</td>
                <td class="primary-color">{{ filter.status ? filter.status : '-' }}</td>
              </tr>
            </table>
          </template>
        </div>
      </v-container>
      <v-divider></v-divider>
      <template v-if="broadcast.isschedule">
        <v-container>
          <div>{{ $t('Schedule Broadcast') }}</div>
          <div class="primary--text">
            {{ broadcast.scheduletime | dateFormat('DD/MM/YYYY hh:mm A') }}
          </div>
        </v-container>
        <v-divider></v-divider>
      </template>
      <v-container>
        <div style="overflow: auto">
          <template v-if="type == 'text'">
            <div>
              <message-viewer v-model="message" style="float: left"></message-viewer>
            </div>
            <div class="clearfix"></div>
          </template>
          <template v-else-if="type == 'template'">
            <generic-viewer v-model="generics" style="float: left"></generic-viewer>
            <div class="clearfix"></div>
          </template>
          <template v-if="type == 'json'">
            <message-viewer v-model="messages" style="float: left"></message-viewer>
          </template>
        </div>
      </v-container>
      <v-divider></v-divider>
      <v-container class="text-xs-center">
        <v-btn outline color="grey" @click="onBack">
          <i class="fas fa-chevron-left mr-1"></i>
          {{ $t('Back') }}
        </v-btn>
      </v-container>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import config from '@/config'
import GenericViewer from '@/components/elements/GenericViewer'
import MessageViewer from '@/components/elements/MessageViewer'
import api from '@/api'

export default {
  props: ['value'],
  data: function() {
    return {
      broadcast: undefined,
      isSave: false,
      isFail: false,
      name: '',
      localeOptions: config.locale,
      intents: [],
      type: 'text',
      groupType: '',
      sendtype: 'subscription',
      pushtype: 'regular',
      message: '',
      quick_reply: '',
      typeOptions: [
        {
          value: 'text',
          name: 'Text'
        },
        {
          value: 'template',
          name: 'Generic'
        }
      ],
      generics: [
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: true
        }
      ],
      messages: [],
      filter: {
        fullname: '',
        gender: 'all',
        locale: null,
        app: 'all',
        intent: null,
        email: '',
        phoneno: '',
        messagesent: {
          value: null,
          symbol: 'g__'
        },
        timezone: {
          from: -12,
          to: 14
        },
        activeDate: {
          enable: false,
          start: moment().toDate(),
          end: moment().toDate()
        },
        registerDate: {
          enable: false,
          start: null,
          end: null
        }
      }
    }
  },
  components: {
    GenericViewer,
    MessageViewer
  },
  mounted: function() {
    var vm = this
    vm.getIntent(function() {})

    vm.reset()
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),

    filterIntent: function() {
      var vm = this
      vm.intents.sort(function(a, b) {
        var nameA = a.intentname.toUpperCase() // ignore upper and lowercase
        var nameB = b.intentname.toUpperCase() // ignore upper and lowercase
        if (a.intentname[0] === '{' && a.intentname[a.intentname.length - 1] === '}') {
          return 1
        }
        if (b.intentname[0] === '{' && b.intentname[b.intentname.length - 1] === '}') {
          return -1
        }
        if (nameA < nameB) {
          return -1
        }
        if (nameA > nameB) {
          return 1
        }

        // names must be equal
        return 0
      })
      var intents = []
      if (vm.intents) {
        vm.intents.map(function(intent, index) {
          intents.push(intent.intentname)
        })
      }
      return intents
    }
  },
  methods: {
    reset: function() {
      var vm = this
      if (vm.value) {
        vm.broadcast = Object.assign({}, vm.value)
        vm.cached_broadcast = Object.assign({}, vm.value)
      }
      if (vm.broadcast) {
        var filters = vm.broadcast.m_condition.split('&')
        if (filters.length > 0) {
          if (filters.length > 1) {
            vm.groupType = 'customize'
          } else {
            var value = filters[0].split(/=(.+)/)
            if (value.length > 1 && value[0] == 'gender') {
              vm.groupType = value[1]
            }
          }
          if (filters) {
            filters.map(function(filter, index) {
              var value = filter.split(/=(.+)/)
              if (value.length > 1) {
                switch (value[0]) {
                  case 'fullname':
                  case 'gender':
                  case 'app':
                  case 'email':
                  case 'status':
                  case 'tags':
                  case 'phoneno':
                    vm.filter[value[0]] = value[1]
                    break
                  case 'messagesent':
                    var messagesent = value[1].split('__')
                    vm.filter[value[0]] = {
                      value: messagesent[1],
                      symbol: messagesent[0] + '__'
                    }
                    break
                  case 'locale':
                    var locales = value[1].split(',')
                    vm.filter.locale = []
                    $.each(locales, function(lindex, locale) {
                      $.each(vm.localeOptions, function(clindex, configLocal) {
                        if (configLocal.value === locale) {
                          vm.filter.locale.push(configLocal)
                          return false
                        }
                      })
                    })
                    break
                  case 'intent':
                    vm.filter.intent = value[1].split(',')
                    break
                  case 'timestamp_from':
                    vm.filter.activeDate.start = moment(value[1]).toDate()
                    break
                  case 'timestamp_to':
                    vm.filter.activeDate.end = moment(value[1]).toDate()
                    break
                  case 'registertimestamp_from':
                    vm.filter.registerDate.start = moment(value[1]).toDate()
                    break
                  case 'registertimestamp_to':
                    vm.filter.registerDate.end = moment(value[1]).toDate()
                    break
                }
              }
            })
          }
        }

        vm.name = vm.broadcast.name
        vm.type = 'json'
        vm.quick_reply = vm.broadcast.m_quick_reply
        vm.sendtype = vm.broadcast.sendtype
        vm.pushtype = vm.broadcast.pushtype

        if (vm.broadcast.m_type == 'template') {
          vm.messages = [
            [
              {
                type: 'generic',
                data: JSON.parse(vm.broadcast.m_val)
              }
            ]
          ]
        } else if (vm.broadcast.m_type == 'json') {
          vm.messages = JSON.parse(vm.broadcast.m_val)
        } else {
          var newGroup = []
          var group = vm.broadcast.m_val.split('||')
          $.each(group, function(index, messages) {
            var newMessage = []
            var group_messages = messages.split('#nl')
            $.each(group_messages, function(index, message) {
              var type = 'text'
              if (!isNaN(message)) {
                newMessage.push({
                  type: 'text',
                  text: message
                })
              } else if (vm.isJsonParseable(message)) {
                var messageParsed = JSON.parse(message)
                newMessage.push({
                  text: messageParsed.text,
                  buttons: messageParsed.buttons,
                  type: 'button'
                })
              } else if (vm.isURL(message)) {
                newMessage.push({
                  type: 'image',
                  image_url: message
                })
              } else {
                newMessage.push({
                  type: 'text',
                  text: message
                })
              }
            })
            newGroup.push(newMessage)
          })
          vm.messages = newGroup
        }
      } else {
        vm.broadcast = undefined
      }
    },
    getIntent: function(callback) {
      let vm = this
      let auth = null
      let data = {
        pageid: vm.selectedBot.pageid
      }
      api.getIntent(data, function(error, response) {
        if (error) {
          console.error(error)
          return
        }
        if (response.data) {
          var isFoundDefault = false
          $.each(response.data, function(index, val) {
            var intent = val
            intent.isShow = false
            vm.intents.push(intent)
          })
        }
        callback()
      })
    },
    onBack: function() {
      var vm = this
      vm.$emit('onClose')
    }
  },
  watch: {
    value: function() {
      this.reset()
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/broadcast/BroadcastView.vue